import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Form, Input, message } from 'antd'
import { AuthContext } from '../Context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { useFetch } from '../../services/ApiService';

function LoginForm() {

  const loginFormRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const auth = useContext(AuthContext);
  const { fetchApi } = useFetch();
  const navigate = useNavigate()

  const handleLogin = async (values) => {
    setBtnLoading(true);

    const payload = {
      email: values.username,
      password: values.password
    }

    await fetchApi('/api/login', 'POST', payload).then(res => {
      //console.log(res.accessToken);
      if (res.accessToken) {
        sessionStorage.setItem("User_Token", res.accessToken);
        auth.updateUserToken();
      }
      if(res.message){
        message.success(res.message);
      }
      if(res.message.toLowerCase().includes('otp')){
        navigate(`/otp-verify?email=${values.username}`);
      }
    }).catch(err => {
      console.log(err);
    })

    setBtnLoading(false);
  }

  

  return (
    <>
      <div className='login-title'>
        <h1 className='mb-1'>Login</h1>
        <p className='small'>Enter your credentials to login</p>
      </div>
      <Form
        name="login-form"
        ref={loginFormRef}
        layout="vertical"
        onFinish={handleLogin}
        autoComplete='off'
      >
        <Form.Item
          label="Username"
          name="username"

          rules={[
            {
              required: true,
              message: 'Username is required',
            },

          ]}
        >
          <Input placeholder='Enter username' />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"

          rules={[
            {
              required: true,
              message: 'Password is required',
            },

          ]}
        >
          <Input.Password placeholder='Enter password' />
        </Form.Item>
        <Button loading={btnLoading} block type="primary" className='px-5 fw-semibold' htmlType="submit" size="large">LOGIN</Button>
        <p className='mt-4 mb-0 text-center text-muted'>Forgot password? <Link to='/forgot-password' className='text-primary'>Recover here</Link></p>
      </Form>
    </>
  )
}

export default LoginForm